<template>
  <!-- 面板 -->
  <div
    ref="layersWrapperRef"
    tabindex="-1"
    class="relative overflow-y-scroll rounded-t-lg no-scollbar bg-black-card text-sm font-normal"
    data-shape-keyboard="true"
    :class="{
      '!bg-[#3B3431] rounded-dash':
        editorStore.attrDisabled && !!editorStore.theme?.children.length
    }"
    @scroll="handleScroll"
    @mouseenter="handleMouseenter"
    @mouseleave="handleMouseleave"
  >
    <Layers
      :is-panel-hovered="isHovered"
      :enable-edit="!editorStore.attrDisabled && !isSlotFollowing"
    />
  </div>
</template>
<script setup lang="ts">
import { computed, provide, ref } from 'vue';
import { debounce } from 'lodash-es';
import { useEditorStore } from '@/store/use-editor-store';
import { useSlotFollow } from '@/hooks/use-slot-follow';

const editorStore = useEditorStore();
const { judgeIfFollowingSlot } = useSlotFollow();

// 图层面板是否悬停
const isHovered = ref(false);

function handleMouseenter() {
  isHovered.value = true;
  updatePanelRect();
}

function handleMouseleave() {
  isHovered.value = false;
}

// 滚动情况
//layersScrollTop提到store中，避免组件销毁后丢失
const layersWrapperRef = ref<HTMLDivElement>();
const layersRect = { top: 0, left: 0 };
provide('layersRect', layersRect);

const handleScroll = debounce((e: UIEvent) => {
  if (e.target) {
    editorStore.setLayersScrollTop((e.target as HTMLElement).scrollTop);
  }
}, 100);

function updatePanelRect() {
  if (layersWrapperRef.value) {
    const rect = layersWrapperRef.value.getBoundingClientRect();
    layersRect.top = rect.top;
    layersRect.left = rect.left;
  }
}

const isSlotFollowing = computed(() => {
  return judgeIfFollowingSlot(
    editorStore.activeShape?.attrs.slotFollowingId ?? undefined
  );
});
</script>
<style lang="less" scoped>
.no-scollbar::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.rounded-dash {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23D45E38' stroke-width='1' stroke-dasharray='12%2c 12' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  background-size: 100% calc(100% + 8px);
  background-repeat: no-repeat;
}
</style>
